/**
 * @copyright Copyright (c) 2016, Pacific Biosciences of California, Inc.
 * @author <a href="mailto:dbarreto@pacificbiosciences.com">David Barreto</a>
 */

import {commonTranslations} from "./common"

export const runQCTranslations = {
    title: "Run QC",
    link: "",
    view: {
        runStart: "Run Start",
        runComplete: "Run Complete",
        transferComplete: "Transfer Complete",
        notTransferred: "not transferred",
        transferred: "transferred",
        instrument: "Instrument",
        instrumentSerialNumber: commonTranslations.instrumentSerialNumber,
        icsSoftwareVersion: "Instrument software",
        primarySoftwareVersion: "Primary SW Version",
        chemistrySoftwareVersion: "Instrument Chemistry Bundle",
        description: commonTranslations.description,
        runId: commonTranslations.runId,
        well: "Well",
        name: commonTranslations.name,
        status: commonTranslations.status,
        movieTime: "Movie Time (hours)",
        extensionTime: "Pre-extension Time (hours)",
        workflow: "Workflow",
        totalBases: "Total Bases (Gb)",
        uniqueMolecularYield: "Unique Molecular Yield (Gb)",
        readLength: "Read Length",
        productivity: "Productivity",
        polymerase: "Polymerase",
        insert: "Longest Subread",
        notYetImported: "Not yet imported:",
        polymeraseReadLength: "Polymerase Read Length",
        insertReadLength: "Longest Subread Length",
        hqBaseFraction: commonTranslations.loadingEvaluation,
        rawReadLength: commonTranslations.loadingEvaluation,
        instrumentSW: "ics",
        primarySW: "primary",
        n50: "N50",
        average: commonTranslations.mean,
        control: "Control",
        concordance: "Concordance",
        controlMean: commonTranslations.mean,
        controlMode: "Mode",
        controlReads: "Total Reads",
        controlReadLength: "Poly RL Mean",
        controlReadLengthPlotCaption: "Control Polymerase RL",
        controlReadQualityPlotCaption: "Control Concordance",
        baseYield: "Base Yield Density",
        hexBinLength: "Read Length Density",
        hqStart: "Distribution of HQ Start Positions",
        localBaseRate: "Local Base Rate",
        template: "Template",
        adapterDimer: "Adapter Dimer",
        shortInsert: "Short Insert"
    }
}
